import useMediaQuery from "@mui/material/useMediaQuery";

const REDUCED_MOTION_QUERY = "(prefers-reduced-motion: reduce)";

/** True while the OS asks for reduced motion; animated chrome renders still. */
export function useReducedMotion(): boolean {
    return useMediaQuery(REDUCED_MOTION_QUERY);
}
